import { render, staticRenderFns } from "./user-address.vue?vue&type=template&id=004ddd28&scoped=true&"
import script from "./user-address.vue?vue&type=script&lang=js&"
export * from "./user-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ddd28",
  null
  
)

export default component.exports